import { Title, Button } from '@gerdau/hefesto';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import useCanGoToPurchase from '../../../hooks/useCanGoToPurchase';
import { ApplicationState } from '../../../store';
import { ECustomerTypeView } from '../../../store/ducks/user/types';
import { hasOnlyCGCustomerTypes } from '../../../utils/commerceUser';
import { GetFlag } from '../../../utils/featureFlag';
import useCmsBlockService from '../../../services/MVP/useCmsBlockService';
import { parseBlockContent } from '../../../components/PageBuilder/parseBlockContent';
import { ERoutes } from '../../../routes';
import { EPurchaseRoutes } from '../../Purchase/purchase.routes';
import {
  BannerContainer,
  BannerSubtitle,
  CmsContent,
  ContentRow,
  ImageSide,
  TextSide
} from './styles';

export const CMS_BLOCK_ID = 'block-home-management';

const MarketCommunicationDashboard: React.FC = () => {
  const showBanner = GetFlag('market_communication_dashboard');
  const isAdobeMode = GetFlag('market_communication_adobe');
  const canGoToPurchase = useCanGoToPurchase();
  const userName = useSelector((state: ApplicationState) => state.user.name);
  const ordersInputCustomers = useSelector(
    (state: ApplicationState) => state.user.roles.ordersInputCustomers
  );
  const searchCustomerType = useSelector(
    (state: ApplicationState) => state.user.searchCustomerType
  );
  const customers = useSelector(
    (state: ApplicationState) => state.customers.customers
  );
  const history = useHistory();

  const isFabricationReceiver =
    searchCustomerType === ECustomerTypeView.FABRICATION_RECEIVER;

  const shouldRender =
    showBanner &&
    canGoToPurchase &&
    !isFabricationReceiver &&
    ordersInputCustomers.length > 0 &&
    !hasOnlyCGCustomerTypes(customers);

  const { content, loading } = useCmsBlockService(
    CMS_BLOCK_ID,
    shouldRender && isAdobeMode
  );

  if (!shouldRender) return null;

  const userFirstName = userName.split(' ')[0] ?? '';
  const welcomeTitle = `Boas vindas, ${userFirstName}`;

  if (isAdobeMode) {
    if (loading || !content) return null;

    return (
      <BannerContainer>
        <Title level={1}>{welcomeTitle}</Title>
        <BannerSubtitle>
          <p className="content">
            Na Gerdau mais você tem transparência e previsibilidade e garante
            uma maior autonomia e agilidade para o seu negócio.
          </p>
        </BannerSubtitle>
        <CmsContent>{parseBlockContent({ html: content })}</CmsContent>
      </BannerContainer>
    );
  }

  const handleNavigate = () => {
    history.push(
      `${ERoutes.PURCHASE}/${EPurchaseRoutes.COMMERCE}/${EPurchaseRoutes.STEEL_TYPE_CHOOSE}`
    );
  };

  return (
    <BannerContainer>
      <Title level={1}>{welcomeTitle}</Title>
      <BannerSubtitle>
        <p className="content">
          Na Gerdau mais você tem transparência e previsibilidade e garante uma
          maior autonomia e agilidade para o seu negócio.
        </p>
      </BannerSubtitle>
      <ContentRow>
        <ImageSide>
          <img src="/market_banners/Meia_Pag.gif" alt="banner de boas-vindas" />
        </ImageSide>
        <TextSide>
          <Title level={2}>Você no controle do seu pedido</Title>
          <p className="content">
            Monte seu pedido, escolha as quantidades e finalize sua compra
            online com rapidez e praticidade.
            <ul>
              <li>Seu pedido entra imediatamente na fila de produção;</li>
              <li>Consulte o prazo de entrega antes de concluir a compra;</li>
              <li>
                Plataforma disponível 24 horas por dia, 7 dias por semana.
              </li>
            </ul>
          </p>
          <Button name="acessar-loja" onClick={handleNavigate}>
            Acessar loja online
          </Button>
        </TextSide>
      </ContentRow>
    </BannerContainer>
  );
};

export default MarketCommunicationDashboard;
